import React, { useEffect, useMemo, useState } from "react";
import "../solutions/Solutions.css";
import { IoChevronBack, IoChevronForward } from "react-icons/io5";

const TRADE_SHOW_CONFIG = {
  slug: "ise-2026",

  hero: {
    backgroundImage:
      "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/stockImages%2FNashville.jpeg?alt=media&token=caa03ce7-e4b7-481a-9a09-d97d4711dc86",

    logo:
      "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/stockImages%2FISE%20Expo%20Logo.png?alt=media&token=1396b634-3e0f-4da9-8b4b-690458dd71c9",

    heading: "ONE NETWORK FUTURE",
    description:
      "Join us at ISE Expo 2026. Let’s bring your vision and our innovation together to shape the future of connectivity.",

    buttonLabel: "Meet me at ISE",
    buttonLink:
      "mailto:brand@gofoton.com?subject=I%E2%80%99d%20like%20to%20meet%20at%20ISE",

    boothLabel: "Booth 817",
    boothLink: "https://iseexpo26.mapyourshow.com/8_0/floorplan/?hallID=campus&level=3&selectedBooth=booth%7E817"
  },

  overview: {
    badge: {
      heading: "ISE Expo Exhibit 817",
      dates: "August 18–20, 2026",
      location: "Nashville, TN",
    },

    description: (
  <>
    Visit us in{" "}
    <a
      href="https://iseexpo26.mapyourshow.com/8_0/floorplan/?hallID=campus&level=3&selectedBooth=booth%7E817"
      target="_blank"
      rel="noopener noreferrer"
    >
      booth 817
    </a>{" "}
    to explore a different approach to solving network problems. Whether
    you’re wondering how to bring{" "}
    <a href="/solutions/ai">AI to the edge</a>, find solutions that are{" "}
    <a href="/bead">BEAD/BABA</a> compliant, or need a partner to bring your
    vision of your network together, we’re here for you. With a broad portfolio
    of modular, scalable connectivity, a willingness to develop custom products
    for you, and professional services, there’s no need to solve today’s
    challenges with yesterday’s solutions.
  </>
),
    passText: "Need a pass?",
    passLinkText: "Register here.",
    passLink: "https://www.iseexpo.com/",
  },

  specialEvents: {
    heading: "Save the date for these special opportunities at ISE Expo",

    cards: [
      {
        title: "Taste of Tennessee",
        subtitle: "Stop by our booth for a local brew",
        image:
          "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/stockImages%2FAdobeStock_175975828%20(1).jpeg?alt=media&token=115c7307-a0b3-4b5d-b674-85c2dd2b5835",

        details: [
          "Booth 817",
          "Tuesday, August 19",
          "5:00 PM – 6:30 PM",
        ],

        buttonLabel: "Add to calendar",

        calendarLink:
          "https://calendar.google.com/calendar/render?action=TEMPLATE&text=Taste%20of%20Tennessee%20at%20ISE%20Expo&dates=20260819T210000Z/20260819T223000Z&details=Stop%20by%20Go!Foton%20Booth%20817%20for%20a%20local%20brew.&location=Booth%20817%2C%20ISE%20Expo%2C%20Nashville%2C%20TN",
      },

      {
        title:
          "Greg Ash presents “A Playbook for Network Deployment in a Resource-Constrained World”",

        subtitle: "",
        image:
          "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/stockImages%2Fgreg%20ash.png?alt=media&token=77b6b2ec-834b-48b1-a375-7b6208054149",

        details: [
          "Convergence Theatre, Exhibit Hall Level 3",
          "Wednesday, August 19",
          "12:30 PM – 1:00 PM",
        ],

        buttonLabel: "Add to calendar",

        calendarLink:
          "https://calendar.google.com/calendar/render?action=TEMPLATE&text=A%20Playbook%20for%20Network%20Deployment%20in%20a%20Resource-Constrained%20World&dates=20260819T163000Z/20260819T170000Z&details=Presentation%20by%20Greg%20Ash%20at%20ISE%20Expo.&location=Convergence%20Theatre%2C%20Exhibit%20Hall%20Level%203%2C%20Nashville%2C%20TN",

        secondaryButtonLabel: "View Preview",
        secondaryButtonLink: "https://www.iseexpo.com/2026/program",
      },
    ],
  },

  featuredProducts: {
    heading: "Get a hands-on look at our featured optical connectivity",

    items: [
      {
        name: "MMT",
        image:
          "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/productImages%2FLeft-Facing.png?alt=media&token=dfe20c9b-7182-4a25-bb79-c898beb6cd0f",
        link: "/mid-size-peacoc-multiport-mid-span-terminal-mmt",
      },
      {
        name: "CORE-KIT",
        image:
          "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/productImages%2FCORE%20kit.webp?alt=media&token=a4f0111a-ca64-4e54-93fc-d820d1fd1195",
        link: "/core-kit",
      },
      {
        name: "EVA",
        image:
          "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/productImages%2F4RU_Stack_Fully-Loaded_open-door_Isometric.webp?alt=media&token=cfe6a686-afc2-4285-bd5a-6e05b1bda297",
        link: "/peacoc-enhanced-view-and-access-eva-high-density-patch-panel",
      },
      {
        name: "Fiber Slack Panel",
        image:
          "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/productImages%2FFiber%20Slack%20Panel%20-%20Open%20-%20L.png?alt=media&token=d0d904aa-d1b2-4a6a-889e-023fdeba3f38",
        link: "/fiber-slack-panel",
      },
      {
        name: "PEACOC 360",
        image:
          "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/productImages%2FP360_IsometricView_NoDoor_2.jpg?alt=media&token=bf4587da-0cbc-4f14-bba3-8ecf99ba2bc2",
        link: "/peacoc-360-spooling-patch-panel",
      },
      {
        name: "APP",
        image:
          "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/productImages%2FPEACOC%20APP%20Panel_%20Isoetric%20View.png?alt=media&token=bac369ea-5caf-4abb-8f99-66c156882543",
        link: "/app",
      },
      {
        name: "Cable Assemblies",
        image:
          "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/productImages%2F%20MPO%2C%20SC%20Simplex%2C%20LC%20Duplex%20Connectors%20web%20(1)%20copy.jpg?alt=media&token=8a638a1f-9568-4659-817a-50f138d30058",
        link: "/family/fiber-cable-assemblies",
      },
      {
        name: "Splitters",
        image:
          "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/productImages%2F10b.5-2x64-PLC-splitter-square-v2.jpg?alt=media&token=cff56c35-7a08-44cb-b2ed-35f84777e79f",
        link: "/family/passive-optical-components",
      },
      {
        name: "Services",
        image:
          "/images/services/ServicesImage.png",
        link: "/services",
      },
    ],
  },

  subscribe: {
    heading: "Can’t make ISE 2026? Let’s stay in touch.",
    buttonLabel: "Subscribe to Go!Foton news",
    buttonLink: "/subscribe",
  },

  otherShows: {
    heading: "Other upcoming shows",

    shows: [
      {
        name: "SCTE TechExpo",
        location: "Atlanta, GA",
        dates: "September 29 – October 1, 2026",
        link: "https://techexpo.scte.org/",
      },
      {
        name: "BICSI Winter",
        location: "Orlando, FL",
        dates: "February 14–18, 2027",
        link: "https://www.bicsi.org/",
      },
      {
        name: "OFC",
        location: "Los Angeles, CA",
        dates: "March 7–11, 2027",
        link: "https://www.ofcconference.org/",
      },
    ],
  },

  mobileUnit: {
    heading: "Need us to come to you?",
    buttonLabel: "Request the Go!Foton mobile demo unit",
    buttonLink:
      "mailto:brand@gofoton.com?subject=I%E2%80%99d%20like%20to%20request%20a%20Go!Foton%20mobile%20demo",
  },
};

function ISE() {
  const [productIndex, setProductIndex] = useState(0);
  const [productsPerView, setProductsPerView] = useState(3);

  useEffect(() => {
    const updateLayout = () => {
      if (window.innerWidth <= 768) {
        setProductsPerView(1);
      } else if (window.innerWidth <= 1100) {
        setProductsPerView(2);
      } else {
        setProductsPerView(3);
      }
    };

    updateLayout();

    window.addEventListener("resize", updateLayout);

    return () => {
      window.removeEventListener("resize", updateLayout);
    };
  }, []);

  const maximumProductIndex = useMemo(() => {
    return Math.max(
      TRADE_SHOW_CONFIG.featuredProducts.items.length - productsPerView,
      0
    );
  }, [productsPerView]);

  useEffect(() => {
    if (productIndex > maximumProductIndex) {
      setProductIndex(maximumProductIndex);
    }
  }, [productIndex, maximumProductIndex]);

  const goToPreviousProduct = () => {
    setProductIndex((current) => Math.max(current - 1, 0));
  };

  const goToNextProduct = () => {
    setProductIndex((current) =>
      Math.min(current + 1, maximumProductIndex)
    );
  };

  return (
<div className="contact-page ise-page">
        {/* ORIGINAL SITE MARQUEE STRUCTURE */}

      <div className="single-marquee">
        <div className="single-marquee-slide">
          <video
            disablePictureInPicture
            controlsList="nodownload nofullscreen noremoteplayback"
            src=""
            poster={TRADE_SHOW_CONFIG.hero.backgroundImage}
            autoPlay
            loop
            muted
            playsInline
          />

          <div className="single-overlay-content">
            <h1>{TRADE_SHOW_CONFIG.hero.heading}</h1>

            <h2>{TRADE_SHOW_CONFIG.hero.eventLine}</h2>

            <p>{TRADE_SHOW_CONFIG.hero.description}</p>

            <a
              href={TRADE_SHOW_CONFIG.hero.buttonLink}
              className="cta-button"
            >
              {TRADE_SHOW_CONFIG.hero.buttonLabel}
            </a>
          </div>

          <div className="ise-expo-logo-wrapper">
            <img
              className="ise-expo-logo"
              src={TRADE_SHOW_CONFIG.hero.logo}
              alt="ISE Expo"
            />

            <div className="ise-expo-booth">
              {TRADE_SHOW_CONFIG.hero.boothLabel}
            </div>
          </div>
        </div>
      </div>

      {/* ORIGINAL SITE CURVED DIVIDER */}

      <svg
        className="section-divider"
        viewBox="0 0 1440 150"
        preserveAspectRatio="none"
      >
        <defs>
          <linearGradient
            id="hardWhiteSplit"
            x1="0"
            y1="0"
            x2="0"
            y2="1"
          >
            <stop
              offset="50%"
              stopColor="white"
              stopOpacity="1"
            />
          </linearGradient>
        </defs>

        <path
          d="
            M0,150
            H1440
            V0
            Q720,75 0,0
            Z
          "
          fill="url(#hardWhiteSplit)"
        />
      </svg>

      {/* OVERVIEW */}

      <section className="trade-show-overview">
        <aside className="trade-show-event-badge">
          <img
            src={TRADE_SHOW_CONFIG.hero.logo}
            alt="ISE Expo"
          />

          <strong>
            {TRADE_SHOW_CONFIG.overview.badge.heading}
          </strong>

          <span>
            {TRADE_SHOW_CONFIG.overview.badge.dates}
          </span>

          <span>
            {TRADE_SHOW_CONFIG.overview.badge.location}
          </span>
        </aside>

        <div className="trade-show-overview-text">
          <p>
            {TRADE_SHOW_CONFIG.overview.description}
          </p>

          <p>
            {TRADE_SHOW_CONFIG.overview.passText}{" "}
            <a
              href={TRADE_SHOW_CONFIG.overview.passLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              {TRADE_SHOW_CONFIG.overview.passLinkText}
            </a>
          </p>
        </div>
      </section>

      {/* SPECIAL EVENTS */}

      <section className="trade-show-section">
        <h2 className="trade-show-section-title">
          {TRADE_SHOW_CONFIG.specialEvents.heading}
        </h2>

        <div className="trade-show-special-events">
          {TRADE_SHOW_CONFIG.specialEvents.cards.map((event) => (
            <article
              className="trade-show-special-card"
              key={event.title}
            >
              <img
                src={event.image}
                alt={event.title}
              />

              <div className="trade-show-special-card-content">
                <h3>{event.title}</h3>

                {event.subtitle && (
                  <h4>{event.subtitle}</h4>
                )}

                <div className="trade-show-special-details">
                  {event.details.map((detail) => (
                    <span key={detail}>
                      {detail}
                    </span>
                  ))}
                </div>

                <div className="trade-show-card-buttons">
                  <a
                    className="trade-show-small-button"
                    href={event.calendarLink}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {event.buttonLabel}
                  </a>

                  {event.secondaryButtonLink && (
                    <a
                      className="trade-show-small-button secondary"
                      href={event.secondaryButtonLink}
                    >
                      {event.secondaryButtonLabel}
                    </a>
                  )}
                </div>
              </div>
            </article>
          ))}
        </div>
      </section>

      {/* FEATURED PRODUCTS */}

      <section className="trade-show-section trade-show-products-section">
        <h2 className="trade-show-section-title">
          {TRADE_SHOW_CONFIG.featuredProducts.heading}
        </h2>

        <div className="trade-show-product-slider">
          <button
            type="button"
            className="trade-show-slider-arrow"
            onClick={goToPreviousProduct}
            disabled={productIndex === 0}
            aria-label="Previous products"
          >
            <IoChevronBack />
          </button>

          <div className="trade-show-product-viewport">
            <div
              className="trade-show-product-track"
              style={{
                transform: `translateX(-${
                  productIndex * (100 / productsPerView)
                }%)`,
                "--trade-products-per-view": productsPerView,
              }}
            >
              {TRADE_SHOW_CONFIG.featuredProducts.items.map(
                (product) => (
                  <div
                    className="trade-show-product-slide"
                    key={product.name}
                  >
                    <a
                      className="trade-show-product-card"
                      href={product.link}
                      target="_blank"
                    >
                      <img
                        src={product.image}
                        alt={product.name}
                      />

                      <div className="trade-show-product-name">
                        {product.name}
                      </div>

                      <span className="cta-button">
                        View
                      </span>
                    </a>
                  </div>
                )
              )}
            </div>
          </div>

          <button
            type="button"
            className="trade-show-slider-arrow"
            onClick={goToNextProduct}
            disabled={productIndex === maximumProductIndex}
            aria-label="Next products"
          >
            <IoChevronForward />
          </button>
        </div>
      </section>

      {/* SUBSCRIBE */}

      <section className="trade-show-subscribe">
        <h2>
          {TRADE_SHOW_CONFIG.subscribe.heading}
        </h2>

        <a
          className="cta-button"
          href={TRADE_SHOW_CONFIG.subscribe.buttonLink}
        >
          {TRADE_SHOW_CONFIG.subscribe.buttonLabel}
        </a>
      </section>

      {/* OTHER SHOWS */}

      <section className="trade-show-section">
        <h2 className="trade-show-section-title">
          {TRADE_SHOW_CONFIG.otherShows.heading}
        </h2>

        <div className="trade-show-other-grid">
          {TRADE_SHOW_CONFIG.otherShows.shows.map((show) => (
            <article
              className="trade-show-other-card"
              key={show.name}
            >
              <h3>{show.name}</h3>

              <p>{show.location}</p>

              <p>{show.dates}</p>

              <a
                href={show.link}
                target="_blank"
                rel="noopener noreferrer"
                className="cta-button"
              >
                View Event
              </a>
            </article>
          ))}
        </div>
      </section>

      {/* MOBILE DEMO */}

      <section className="trade-show-mobile-unit">
        <h2>
          {TRADE_SHOW_CONFIG.mobileUnit.heading}
        </h2>

        <a
          className="cta-button"
          href={TRADE_SHOW_CONFIG.mobileUnit.buttonLink}
        >
          {TRADE_SHOW_CONFIG.mobileUnit.buttonLabel}
        </a>
      </section>
    </div>
  );
}

export default ISE;